module.exports = __webpack_public_path__ + "img/herd.319dee1c.jpg";